import script from "./MEventoPeriodo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MEventoPeriodo.vue?vue&type=script&lang=ts&setup=true"

import "./MEventoPeriodo.vue?vue&type=style&index=0&id=5c7f2a3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7f2a3a"]])

export default __exports__